import { html, svg } from 'lit';

export const playIcon = svg`
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
    <path d="M 10 7 L 24 16 L 10 25 Z" fill="currentColor" />
  </svg>
`;

export const pauseIcon = svg`
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" aria-hidden="true">
    <rect x="9" y="7" width="4.5" height="18" rx="1" fill="currentColor" />
    <rect x="18.5" y="7" width="4.5" height="18" rx="1" fill="currentColor" />
  </svg>
`;

export const chevronDownIcon = html`
  <svg
    class="model-select-chevron"
    width="10"
    height="6"
    viewBox="0 0 10 6"
    aria-hidden="true"
  >
    <path d="M 1 1 L 5 5 L 9 1" stroke="currentColor" stroke-width="1.4" fill="none" />
  </svg>
`;
